import { useRef } from "react";

export const MagneticButton = ({ children, className = "", strength = 0.35, as = "button", ...rest }) => {
  const Comp = as;
  const ref = useRef(null);

  const handleMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = e.clientX - (rect.left + rect.width / 2);
    const y = e.clientY - (rect.top + rect.height / 2);
    el.style.transform = `translate(${x * strength}px, ${y * strength}px)`;
  };

  const handleLeave = () => {
    if (ref.current) ref.current.style.transform = "translate(0,0)";
  };

  return (
    <Comp
      ref={ref}
      onMouseMove={handleMove}
      onMouseLeave={handleLeave}
      className={`magnet ${className}`}
      {...rest}
    >
      {children}
    </Comp>
  );
};

export default MagneticButton;
